//#region src/components/ThemeProvider/utils.ts
const createTheme = (brand) => ({
	id: brand.id,
	name: brand.name,
	shell: brand.shell,
	logo: brand.logo
});
const createCssVars = () => {
	const vars = {};
	return {
		set: (name, value) => {
			if (value !== void 0) vars[name] = value;
		},
		expose: () => ({ ...vars })
	};
};
//#endregion
//#region src/components/ThemeProvider/defaults.ts
const DEFAULT_COLOR_SCHEME = "light";
const DEFAULT_BRAND_ID = "design-system";
const defaultBrand = {
	id: DEFAULT_BRAND_ID,
	name: "Design System",
	shell: "sidebar",
	theme: {}
};
const defaultTheme = createTheme(defaultBrand);
const DEFAULT_BRANDS = [];
//#endregion
export { DEFAULT_BRANDS, DEFAULT_BRAND_ID, DEFAULT_COLOR_SCHEME, createCssVars, createTheme, defaultBrand, defaultTheme };

//# sourceMappingURL=defaults-i_xG2F_1.js.map